import { render, staticRenderFns } from "./scenario_popup_report.vue?vue&type=template&id=6aba271b&scoped=true&lang=pug&"
import script from "./scenario_popup_report.vue?vue&type=script&lang=js&"
export * from "./scenario_popup_report.vue?vue&type=script&lang=js&"
import style0 from "./scenario_popup_report.vue?vue&type=style&index=0&id=6aba271b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba271b",
  null
  
)

export default component.exports